import copy from 'copy-to-clipboard'

/**
 * Copy text to clipboard
 * @returns a promise that resolves when the text has been copied
 */
export const copyToClipboard = (text: string) =>
    new Promise<void>((resolve, reject) => {
        try {
            copy(text, {
                onCopy: () => {
                    resolve()
                },
            })
        } catch (error) {
            reject(error)
        }
    })
